import { atomWithStorage } from "jotai/utils";
export const THEME_STORAGE_KEY = "sentinel-theme";
export const themePreferenceAtom = atomWithStorage(THEME_STORAGE_KEY, "auto");
